// extracted by mini-css-extract-plugin
export default {"header":"Header_header__AIE31","logo":"Header_logo__d5IDJ"};